import React from 'react';
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiCheck, FiFlag } from "react-icons/fi";
import "./GolasKpisUpsale.scss";
import GoalsandKPIsStatus from '../images/GoalsandKPIsStatus.png';
import Goalschart from '../images/Goalschart.png';
import { BsCheckCircleFill, BsFillXCircleFill } from "react-icons/bs";

const GolasKpisUpsale = ({ t }) => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/company_admin/home");
  };

  const handleContactUpgrade = () => {
    // Handle contact upgrade action
    console.log("Contact upgrade clicked");
  };

  return (
    <div className="golas-kpis-upsale" data-testid="golas-kpis-upsale">
      {/* Top Section - Light Gray Background */}
      <section className="top-section" data-testid="top-section">
        <div className="container">
          <div className="row m-0">
            {/* Left Column - Text Content */}
            <div className="col-md-5">
              <div className="content-wrapper">
                <h2 className="main-heading mb-4" data-testid="main-heading">
                  {t("GolasKpisUpsale.topSection.heading.label")}
                </h2>
                <p className="description" >
                  {t("GolasKpisUpsale.topSection.description.label")}
                </p>
                <div className="mb-4">
                  <b>
                    {t("GolasKpisUpsale.topSection.upgradeNotice.label")}
                  </b>
                </div>
                <div className="button-group" data-testid="button-group">
                  <a
                    href="mailto:info@ecodrisil.com"
                    className="btn btn-primary upgrade-btn"
                  >
                    {t("GolasKpisUpsale.topSection.upgradeButton.label")}
                  </a>
                  <button
                    className="btn btn-outline-secondary home-btn"
                    onClick={handleBackToHome}
                    data-testid="upgrade-btn"
                  >
                    {t("SaaSUpgrade.topSection.goToHome.label")}
                  </button>
                </div>
              </div>
            </div>

            {/* Right Column - Picture */}
            <div className="col-md-7">
              <div className="image-wrapper" data-testid="top-image-wrapper">
                <div className="dashboard-image" data-testid="dashboard-image">
                  {/* Placeholder for dashboard screenshot */}
                  <img src={GoalsandKPIsStatus} alt="Golas Kpis Upsale" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Middle Section - White Background */}
      <section className="middle-section" data-testid="middle-section">
        <div className="container">
          <div className="row m-0">
            {/* Left Column - Picture */}
            <div className="col-md-6">
              <div className="image-wrapper" data-testid="middle-image-wrapper">
                <div className="dashboard-image" data-testid="middle-dashboard-image">
                  <img src={Goalschart} alt="Golas Kpis Upsale" />
                </div>
              </div>
            </div>

            {/* Right Column - Text Content */}
            <div className="col-md-6">
              <div className="content-wrapper" data-testid="middle-content-wrapper">
                <h2 className="section-title" data-testid="section-title">
                  {t("GolasKpisUpsale.middleSection.title.label")}
                </h2>
                <ul className="feature-list" data-testid="feature-list">
                  <li className="feature-item" data-testid="feature-item-1">
                    <FiFlag className="check-icon" />
                    <span>{t("GolasKpisUpsale.middleSection.feature1.label")}</span>
                  </li>
                  <li className="feature-item" data-testid="feature-item-2">
                    <FiFlag className="check-icon" />
                    <span>{t("GolasKpisUpsale.middleSection.feature2.label")}</span>
                  </li>
                  <li className="feature-item" data-testid="feature-item-3">
                    <FiFlag className="check-icon" />
                    <span>{t("GolasKpisUpsale.middleSection.feature3.label")}</span>
                  </li>
                  <li className="feature-item" data-testid="feature-item-4">
                    <FiFlag className="check-icon" />
                    <span>{t("GolasKpisUpsale.middleSection.feature4.label")}</span>
                  </li>
                  <li className="feature-item" data-testid="feature-item-5">
                    <FiFlag className="check-icon" />
                    <span>{t("GolasKpisUpsale.middleSection.feature5.label")}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Section - Comparison Table */}
      <section className="bottom-section" data-testid="bottom-section">
        <div className="container px-4">
          <div className='mb-3'>
            <h4 className="step-up-title fw-bold" data-testid="step-up-title">
              Step Up Your Plan
            </h4>
          </div>
          <div className='row m-0 OurPlansSection'>
            <div className='col-md-6 p-2'>
              <div className='OurPlansSection_List'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>{t("OurPlans.label")}</h6>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GolasKpisUpsale.bottomSection.table.goalsDashboard.label")}</h6>
                    <p>{t("GolasKpisUpsale.bottomSection.table.customizableDashboard.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GolasKpisUpsale.bottomSection.table.goalSettings.label")}</h6>
                    <p>{t("GolasKpisUpsale.bottomSection.table.globalsettings.plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GolasKpisUpsale.bottomSection.table.goalsTracker.label")}</h6>
                    <p>{t("GolasKpisUpsale.bottomSection.table.goalsTracker.Plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GolasKpisUpsale.bottomSection.table.actionsTracker.label")}</h6>
                    <p>{t("GolasKpisUpsale.bottomSection.table.actionsTracker.Plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GolasKpisUpsale.bottomSection.table.analytics.label")}</h6>
                    <p>{t("GolasKpisUpsale.bottomSection.table.analytics.Plan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("GolasKpisUpsale.bottomSection.table.aiInsights.label")}</h6>
                    <p>{t("GolasKpisUpsale.bottomSection.table.aiInsights.Plan.label")}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-3 p-2'>
              <div className='OurPlansSection_List Current-planList'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>
                      {t("GolasKpisUpsale.bottomSection.table.currentPlan.label")}
                    </h6>
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-3 p-2'>
              <div className='OurPlansSection_List Current-planList'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>
                      {t("GolasKpisUpsale.bottomSection.table.upgradedPlan.label")}
                    </h6>
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>

                </ul>
              </div>
            </div>
          </div>
          <div className="button-group text-right p-2" data-testid="button-group">
            <a
              href="mailto:info@ecodrisil.com"
              className="btn btn-primary upgrade-btn"
            >
              {t("GolasKpisUpsale.topSection.upgradeButton.label")}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withTranslation()(GolasKpisUpsale);
